import useLocalStorageState from "@/hooks/useLocalStorageState";
import ControlBar from "./ControlBar";
import { withHistoryState } from "./ControlBar/HistoryFilter/history-filter-store";
import GraphView from "./GraphView";
import TableView from "./TableView";
import { EvaluationHistoryProps } from "./types";

const EvaluationHistory = ({
  usePromptId = true,
  useParentReportId = false,
  displayAll = false,
  showViewButtons = true,
  showTitle = true,
  tableProps,
  graphProps,
}: EvaluationHistoryProps) => {
  const [view, setView] = useLocalStorageState<"graph" | "table">(
    "PROMPT_OVERVIEW_VIEW_TYPE",
    "graph",
  );

  return (
    <div className="flex h-full flex-col overflow-y-auto pt-2">
      <ControlBar
        activeView={view}
        onViewChange={setView}
        showViewButtons={showViewButtons}
        showTitle={showTitle}
      />
      {showViewButtons ? (
        <>
          <div className="min-h-0 flex-1 ">
            {view === "graph" ? (
              <GraphView
                displayAll={displayAll}
                usePromptId={usePromptId}
                useParentReportId={useParentReportId}
                {...graphProps}
              />
            ) : (
              <TableView
                displayAll={displayAll}
                usePromptId={usePromptId}
                useParentReportId={useParentReportId}
                {...tableProps}
              />
            )}
          </div>
        </>
      ) : (
        <div className="flex flex-col gap-4">
          <div className="flex max-h-[350px] min-h-[350px]">
            <GraphView
              displayAll={displayAll}
              usePromptId={usePromptId}
              useParentReportId={useParentReportId}
              {...graphProps}
            />
          </div>
          <TableView
            displayAll={displayAll}
            usePromptId={usePromptId}
            useParentReportId={useParentReportId}
            displayPlaceholder={showViewButtons}
            {...tableProps}
          />
        </div>
      )}
    </div>
  );
};

export default withHistoryState(EvaluationHistory);
